<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col md="12">
        <component-header
          title="Edit Access Rules"
          :hasSearch="false"
          :hasReload="false"
          :hasCreate="false"
          :hasback="true"
          @back-press="$router.push({ path: '/setup/accessrule' })"
        />
      </b-col>
      <b-col md="12">
        <b-card>
          <ValidationObserver v-slot="{ invalid }">
            <form>
              <b-row class="mt-4">
                <b-col md="6">
                  <label for="planName">Name</label>
                  <ValidationProvider
                    rules="required"
                    v-slot="{ errors }"
                    name="planName"
                  >
                    <b-form-input
                      id="planName"
                      inputType="text"
                      v-model="detailsAccess.name"
                    />
                    <span class="validate-error">{{ errors[0] }}</span>
                  </ValidationProvider>
                </b-col>
                <b-col md="6">
                  <label for="keys">keys </label>
                  <ValidationProvider
                    rules="required"
                    v-slot="{ errors }"
                    name="keys"
                  >
                    <multiselect
                      v-model="detailsAccess.keys"
                      tag-placeholder="Add this as new keys"
                      placeholder="Select keys List"
                      label="name"
                      track-by="keys"
                      :options="permissions"
                      :multiple="true"
                      :taggable="false"
                      :open-direction="'bottom'"
                    ></multiselect>
                    <span class="validate-error">{{ errors[0] }}</span>
                  </ValidationProvider>
                </b-col>
              </b-row>
              <div class="text-center">
                <button
                  type="button"
                  class="btn btn-primary mt-4"
                  :disabled="invalid"
                  classic="btn-primary"
                  text="Update"
                  @click.prevent="handleSubmit"
                >
                  Update
                </button>
              </div>
            </form>
          </ValidationObserver>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  ValidationProvider,
  ValidationObserver,
} from "vee-validate/dist/vee-validate.esm";
import { listPermissions } from "@/services/auth";
import ebButton from "@/components/FormElements/Button";
import ComponentHeader from "@/components/componentNewHeader";
export default {
  name: "editaccessrule",
  components: {
    ebButton,
    ValidationProvider,
    ValidationObserver,
    ComponentHeader,
  },
  data: () => {
    return {
      permissions: [],
      detailsAccess: {
        name: "",
        keys: "",
      },
      details: "",
    };
  },
  methods: {
    async handleSubmit() {
      let x = [];
      let data = {};
      if (this.detailsAccess.keys.length > 0) {
        this.detailsAccess.keys.forEach((obj) => {
          x.push(obj.keys);
        });
        data = {
          name: this.detailsAccess.name,
          keys: x,
        };
      }
      let payload = {
        id: this.details.itemId,
        data: data,
      };
      await this.$store
        .dispatch("accessrule/editAccessrule", payload)
        .then(async () => {
          await this.$store.dispatch("accessrule/accessRuleList");
          this.$swal({
            title: "Success",
            text: "Access Rules Edited successfully!!",
            type: "success",
          });
          this.$router.push({ path: "/setup/accessrule" });
        })
        .catch((err) => {
          this.$swal({
            title: "Opps!!!!!",
            text: "Unable to Edit Access Rule",
            type: "error",
          });
        });
    },
  },
  async mounted() {
    this.details = this.$route?.params?.data || "";
    if (this.details) {
      let roleKeys = [];
      this.details?.Keys.map((obj) => {
        let eachKey = {
          name: obj,
          keys: obj,
        };
        roleKeys.push(eachKey);
      });
      this.detailsAccess.name = this.details?.Name;
      this.detailsAccess.keys = roleKeys;
    }

    try {
      const result = await listPermissions();
      this.permissions = result.response.map((d) => {
        return {
          name: d.name,
          keys: d.name,
        };
      });
    } catch (e) {
      this.$toasted.error(e.message);
    }
  },
};
</script>
<style scoped>
.fa-plus {
  border-top-right-radius: 10px;
  border-top-left-radius: 17px;
  border-bottom-left-radius: 17px;
  background-color: #f0f3f5;
}
.myDIV:hover + .hide {
  display: block;
  position: absolute;
}
.hide {
  display: none;
  font-size: 11px;
}
</style>
